// extracted by mini-css-extract-plugin
export var dropdownIcon = "_px-6";
export var imgContainer = "_px-3";
export var menuIcon = "_px-5";
export var pillWrapper = "_px-2";
export var pillsContainer = "_px-1";
export var subscriptionCard = "_px-0";
export var subscriptionLogo = "_px-4";